import {
  fetchWebGetUserFavorites,
  TWebGetUserFavoritesRequest,
  TWebGetUserFavoritesResponse,
} from '../repositories/favorites/v1/web/get-user-favorites';
import { IThunkContext } from '../types/redux';

export const fetchUserFavorites = (context: IThunkContext, parameters: TWebGetUserFavoritesRequest) => {
  const { httpApi, logger } = context;

  return fetchWebGetUserFavorites({ httpApi, parameters })
    .then((response: TWebGetUserFavoritesResponse) => {
      if (response.statusCode !== 200) {
        return null;
      }

      const {
        response: { canLoadMore, favoriteEntities, folders, folderCount, counts, clientCommentToFolder },
      } = response;

      return {
        canLoadMore,
        favoriteEntities,
        folders,
        folderCount,
        counts,
        clientCommentToFolder,
      };
    })
    .catch(error => {
      logger.error(error, {
        domain: 'fetchDesktopGetUserFavorites',
        details: {
          repository: 'frontend-favorites',
          service: 'favorites',
        },
      });

      return null;
    });
};
